const stats = [
  { k: "200%", v: "Organic Traffic Growth", d: "in 15 months" },
  { k: "4% → 10%", v: "Organic Lead Contribution", d: "share of pipeline" },
  { k: "900 → 60K+", v: "Keyword Visibility", d: "ranking keywords" },
  { k: "8 → 41", v: "Domain Authority", d: "growth in DA" },
  { k: "25+", v: "SEO Professionals", d: "team managed" },
  { k: "6K → 20K", v: "LinkedIn Followers", d: "in 3 months" },
];

export default function Stats() {
  return (
    <section id="results" className="bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Proven Results</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            Numbers that speak louder than promises.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed">
            Real, measurable outcomes delivered across SEO, paid media and lifecycle marketing programs.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-6">
          {stats.map((s, i) => (
            <div
              key={s.v}
              data-testid={`stat-${i}`}
              className="reveal bg-white rounded-3xl border border-slate-200 p-6 md:p-8 hover:border-blue-200 hover:shadow-lg transition-all"
            >
              <div className="font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
                {s.k}
              </div>
              <div className="mt-3 font-semibold text-slate-800 text-sm md:text-base">{s.v}</div>
              <div className="text-xs md:text-sm text-slate-500 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
